import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import DefaultButton from '../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import GenerateZoomReportViewModel from './generate-zoom-report.viewmodel';
import * as mobxReact from 'mobx-react';
import './generate-zoom-registration-report-popover.scss';
import { MeetingsReportTableLayout } from '../../shared/meetings-report-table-layout/meetings-report-table-layout';
import { IMeetingsReportItem, ReportType } from '../../../../../api/reports.dao';
import { meetingRegistrationReportText, webinarReportsTitle, zoomMeetingsReportsTitle } from '../../../../../constants/report-labels.constants';

interface IProps {
    intl: IntlShape;
    popoverIsOpen: boolean;
    closePopover: () => void;
    vm: GenerateZoomReportViewModel;
}

const GenerateZoomReportPopover = injectIntl(mobxReact.observer((props: IProps) => {
    const {
        popoverIsOpen,
        closePopover,
        vm
    } = props;


    const isEmpty = vm && !vm.reportsList?.length && !vm.loading;

    const tableList: IMeetingsReportItem[] = vm && vm.reportsList?.map(value => {
        return {
            ...value,
            id: value.connectionId,
            type: value.meetingType
        };
    });

    const title = vm?.reportType === ReportType.ZOOM_WEBINAR_REGISTRATION
        ? <FormattedMessage
            id='oe.reports.generateWebinarRegistrationReport'
            defaultMessage='Generate Webinar Registration Report'
            description='Title text'
          />
        : vm?.reportType === ReportType.ZOOM_MEETING_REGISTRATION_REPORT
        ? <FormattedMessage {...meetingRegistrationReportText} />
        : <FormattedMessage
            id='oe.reports.generateWebinarAttendeeReport'
            defaultMessage='Generate Webinar Attendee Report'
            description='Title text'
          />;

    const reportsTitle = vm?.reportType === ReportType.ZOOM_MEETING_REGISTRATION_REPORT ? zoomMeetingsReportsTitle : webinarReportsTitle;

    return (
        <CommonModal
            title={title}
            isOpen={popoverIsOpen}
            onRequestClose={closePopover}
            className='generate-report-popover'
            footer={(
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        text={
                            <FormattedMessage
                                id='oe.reports.generateNow'
                                defaultMessage='Generate Now'
                                description='Button label'
                            />
                        }
                        modifier={['fat', 'confirm-safe']}
                        disabled={vm && (vm.loading || vm.reportsGenerating || !vm.checkedReportsList.length)}
                        onClick={vm && vm.handleGenerateReports}
                    />
                    <DefaultCloseModalButton/>
                </div>
            )}>
            {
                vm && <MeetingsReportTableLayout
                        isEmpty={isEmpty}
                        handleCheckAll={vm.handleCheckAllReports}
                        className={'meetings-report-popover-body__wrapper'}
                        title={reportsTitle}
                        list={tableList}
                        loading={vm.loading}
                        eventTimezone={vm.getEventTimezone()}
                        checkOne={value => vm.handleReportCheck(value)}
                        isValueChecked={vm.isReportChecked}
                        checkedAll={vm.isAllReportsChecked()}
                        reportType={vm.reportType}
                    />

            }
        </CommonModal>
    );
}));


export {GenerateZoomReportPopover};
